import { db } from "./connect";
import {
  setDoc,
  doc,
  getDoc,
  updateDoc,
  collection,
  onSnapshot,
} from "firebase/firestore";
import IUserModel, { IUserRollType } from "./models/user";

class UserService {
  collectionName = "employes";

  async getUserById(uid: string): Promise<string | IUserModel> {
    try {
      if (!uid) {
        return Response.emptyFills;
      }
      const docRef = doc(db, this.collectionName, uid);
      const snap = await getDoc(docRef);
      const userData = snap.data() as IUserModel;
      if (!snap || !userData) {
        return Response.systemError;
      }
      return userData;
    } catch (err) {
      console.log(err);
      return Response.systemError;
    }
  }

  getRealtime(uid: string, func: any) {
    if (!uid) {
      return Response.emptyFills;
    }
    const docRef = doc(db, this.collectionName, uid);
    onSnapshot(docRef, func);
  }

  getUsersRealTime(func: any) {
    const collRef = collection(db, this.collectionName);
    onSnapshot(collRef, func);
  }

  async verifyCustomer(uid: string): Promise<string | boolean> {
    try {
      if (!uid) {
        return Response.emptyFills;
      }
      const docRef = doc(db, "customers", uid);
      const document = await getDoc(docRef);
      const user = document.data();

      if (user) {
        return "OK";
      }
      return false;
    } catch (err) {
      console.log(err);
      return Response.systemError;
    }
  }

  async updateData(uid = "", data: Partial<IUserModel>) {
    try {
      if (!uid) {
        return Response.noUid;
      }
      if (!data) {
        return Response.noData;
      }

      const docRef = doc(db, this.collectionName, uid);
      await updateDoc(docRef, { ...data });
      return "OK";
    } catch (err) {
      console.log("error", err);
      return Response.systemError;
    }
  }

  async create(uid: string, userData: IUserModel): Promise<string> {
    try {
      if (!uid || !userData) {
        return Response.emptyFills;
      }
      const docRef = doc(db, this.collectionName, uid);
      await setDoc(docRef, userData);
      return "OK";
    } catch (err) {
      return Response.systemError;
    }
  }

  async pushTokenAction(user: Partial<IUserModel>, pushToken = "") {
    if (!user.pushTokens || !user.pushTokens?.length) {
      return await this.updateData(user.uid, { pushTokens: [pushToken] });
    }

    if (!user.pushTokens?.includes(pushToken)) {
      return await this.updateData(user.uid, {
        pushTokens: [...user.pushTokens, pushToken],
      });
    }
    return;
  }

  changeStatus(uid: string, status: boolean, isAdmin = false): Promise<string> {
    return (async (): Promise<string> => {
      try {
        if (!isAdmin) {
          return Response.actionDenied;
        }
        if (!uid) {
          return Response.emptyFills;
        }
        await this.updateData(uid, { status });
        return "OK";
      } catch (err) {
        console.log(err);
        return Response.systemError;
      }
    })();
  }

  changeRoll(
    uid: string,
    roll: IUserRollType,
    isAdmin = false
  ): Promise<string> {
    return (async (): Promise<string> => {
      try {
        if (!isAdmin) {
          return Response.actionDenied;
        }
        if (!uid) {
          return Response.emptyFills;
        }

		await this.updateData(uid, { roll });
        return "OK";
      } catch (err) {
        console.log(err);
        return Response.systemError;
      }
    })();
  }
}
export const Response = {
  noUid: "no uid",
  noData: " no data",
  emptyFills: "empty fills",
  actionDenied: "action denied",
  systemError: "system error",
};

export default UserService;
